import React from 'react';
import meb from '../images/meb.png';
import nzgovt from '../images/nzgovt-logo-black.png';
import styles from './JoinUnion.module.scss';

const Footer = () => {
  return (
    <footer className="footer">
      <div className={styles.footerContainer}>
        <div className="footer-left">
          <img src={meb} alt="ministry of education and business" className="footer-image" />
        </div>
        <div className="footer-right">
          <img src={nzgovt} alt="nz government" className="footer-image" />
        </div>
      </div>
    </footer>
  );
};

export default Footer;